import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { DataService } from '../data.service';
import {LoginModel} from '../models/loginModel'
import {LoginResponseModel} from '../models/loginResponseModel'
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private router: Router, public data: DataService) { }

  public login : LoginModel = new LoginModel();
  public errMessage : string = "";
  ngOnInit(): void {
    this.data.showBackButton = false;
  }

  onLoginSubmit() :void {
    this.errMessage = "";
      if (!this.validate()){
      return;
    }

    this.data.request<LoginResponseModel>("login",this.login,"POST").subscribe((e)=>{
      this.data.token = e.token;
      this.data.SelectedCardNumber = this.login.cardnumber;
      this.data.SelectedCardBearerID = this.login.bearerid;
      //this.router.navigate(["otpprompt"],{skipLocationChange: true});
      this.data.token = e.token;
      this.data.isLoggedIn = true;


      this.data.RaiseEvent("login");
      this.router.navigate(['loadingprogress'],{skipLocationChange:true});

    
    
    },(error)=>{
      this.errMessage = "Invalid details, please try again";
    })
  }

  aadhaarLogin(){
    this.router.navigate([""], { skipLocationChange: true });

  }

  onbtnClick(){
  }

  validate(): boolean {
    if (!new RegExp('^[0-9]{16}$').test(this.login.cardnumber)){
      this.errMessage = "16 digit property number is required";
      return false;
    } else if (!new RegExp('^[a-zA-Z]{4}[0-9]{4}$').test(this.login.bearerid)){
      this.errMessage = "Valid card bearer ID is required";
      return false;
    }else if (!new RegExp('^[0-9]{6}$').test(this.login.pin)){
      this.errMessage = "6 digit pin is required";
      return false;
    }else {
      this.errMessage = '';
      return true;
    }
  }

}
